var _module = require('../../components/module.js');

_module.service('searchFilterParams', [
    '$log',

    function searchFilterParams($log) {
        return {
            get: function () {
                var possibleParams = [
                    {
                        id: 'buyingtimeframe',
                        title: 'When do you want to buy?',
                        values: [
                            {
                                id: '0-60 days',
                                title: '0-60 Days'
                            },
                            {
                                id: '0-120 days',
                                title: '0-120 Days'
                            },
                            {
                                id: '0-180 days',
                                title: '0-180 Days'
                            },
                            {
                                id: 'someday',
                                title: 'Someday'
                            }
                        ],
                        selected: null,
                        selectedTitle: null
                    },
                    {
                        id: 'whatsimportant',
                        title: 'What is most important to you?',
                        values: [
                            {
                                id: 'walkability',
                                title: 'Walkability'
                            },
                            {
                                id: 'restaurants',
                                title: 'Restaurants'
                            },
                            {
                                id: 'outdoors',
                                title: 'Outdoors'
                            },
                            {
                                id: 'all',
                                title: 'All'
                            }
                        ],
                        selected: null,
                        selectedTitle: null
                    },
                    {
                        id: 'schools',
                        title: 'How important are good schools to you?',
                        values: [
                            {
                                id: 'very',
                                title: 'Very Important'
                            },
                            {
                                id: 'somewhat',
                                title: 'Somewhat Important'
                            },
                            {
                                id: 'not so much',
                                title: 'Not So Much'
                            }
                        ],
                        selected: null,
                        selectedTitle: null
                    },
                    {
                        id: 'hometype',
                        title: 'Home Type?',
                        values: [
                            {
                                id: 'attached',
                                title: 'Attached Home'
                            },
                            {
                                id: 'detached',
                                title: 'Detached Home'
                            },
                            {
                                id: 'either',
                                title: 'Either'
                            }
                        ],
                        selected: null,
                        selectedTitle: null
                    },
                    {
                        id: 'bedrooms',
                        title: 'How many bedrooms?',
                        values: [
                            {
                                id: '1',
                                title: 'Studio/1'
                            },
                            {
                                id: '2',
                                title: '2'
                            },
                            {
                                id: '3',
                                title: '3'
                            },
                            {
                                id: '2-3',
                                title: '2-3',
                                needs23Value: true
                            },
                            {
                                id: '4+',
                                title: '4+'
                            },
                            {
                                id: 'any',
                                title: 'Any',
                                needs23Value: true
                            }
                        ],
                        selected: null,
                        selectedTitle: null
                    },
                    {
                        id: 'bathrooms',
                        title: 'How many bathrooms?',
                        values: [
                            {
                                id: '1-2',
                                title: '1-2'
                            },
                            {
                                id: '3-4',
                                title: '3-4'
                            },
                            {
                                id: '5+',
                                title: '5+'
                            },
                            {
                                id: 'any',
                                title: 'Any'
                            }
                        ],
                        selected: null,
                        selectedTitle: null
                    },
                    {
                        id: 'age',
                        title: 'Age of Home?',
                        values: [
                            {
                                id: '< 10',
                                title: '< 10 Years Old'
                            },
                            {
                                id: '10-50',
                                title: '10-50 Years Old'
                            },
                            {
                                id: '50+',
                                title: '50+ Years Old'
                            },
                            {
                                id: 'any',
                                title: 'Any'
                            }
                        ],
                        selected: null,
                        selectedTitle: null
                    },
                    {
                        id: 'stories',
                        title: 'How many stories?',
                        values: [
                            {
                                id: '1',
                                title: '1 Story'
                            },
                            {
                                id: '2+',
                                title: '2+ Stories'
                            },
                            {
                                id: 'either',
                                title: 'Either'
                            }
                        ],
                        selected: null,
                        selectedTitle: null
                    },
                    {
                        id: 'sqfeet',
                        title: 'How many square feet?',
                        values: 'number',
                        selected: null,
                        selectedTitle: null
                    },
                    {
                        id: 'lotsize',
                        title: 'Lot (yard) size?',
                        values: [
                            {
                                id: 'small',
                                title: 'Small'
                            },
                            {
                                id: 'medium',
                                title: 'Medium'
                            },
                            {
                                id: 'large',
                                title: 'Large'
                            },
                            {
                                id: 'any',
                                title: 'Any'
                            }
                        ],
                        selected: null,
                        selectedTitle: null
                    },
                    // Removed 2018-08-07 by LC
                    // {
                    //     id: 'sellerscontact',
                    //     title: 'Sellers can contact me:',
                    //     values: [
                    //         {
                    //             id: 'my loan officer or agent',
                    //             title: 'Only via my loan officer or agent'
                    //         },
                    //         {
                    //             id: 'anyone',
                    //             title: 'Directly and via my loan officer or agent'
                    //         }
                    //     ],
                    //     selected: null,
                    //     selectedTitle: null
                    // },
                    // Removed 2019-06-11 by AB
                    // {
                    //     id: 'notifyme',
                    //     title: 'Please notify me when there are:',
                    //     values: [
                    //         {
                    //             id: 'off market only',
                    //             title: 'Only off-market listings'
                    //         },
                    //         {
                    //             id: 'anything',
                    //             title: 'Off-market and on-market listings'
                    //         }
                    //     ],
                    //     selected: null,
                    //     selectedTitle: null
                    // }
                ];

                return possibleParams;
            }
        };
    }
]);
